import React from 'react';

const img = (key, fallback) =>
  (window.foxQuoteFormImages && window.foxQuoteFormImages[key]) || fallback;

const BASE_URL = 'https://foxwindowsanddoors.com/app/uploads/form';

// Internal products door handles
const internalDoorsHandles = [
  {
    id: 'contemporary-matt-black',
    name: 'Contemporary Matt Black',
    image: img('internal_products_hardware_contemporary_matt_black', `${BASE_URL}/internal-products/hardware/contemporary-matt-black.webp`),
  },
  {
    id: 'signature-knurled-antique-brass',
    name: 'Signature Knurled Antique Brass',
    image: img('internal_products_hardware_signature_knurled_antique_brass', `${BASE_URL}/internal-products/hardware/signature-knurled-antique-brass.webp`),
  },
  {
    id: 'signature-knurled-brushed-black',
    name: 'Signature Knurled Brushed Black',
    image: img('internal_products_hardware_signature_knurled_brushed_black', `${BASE_URL}/internal-products/hardware/signature-knurled-brushed-black.webp`),
  },
  {
    id: 'signature-knurled-brushed-bronze',
    name: 'Signature Knurled Brushed Bronze',
    image: img('internal_products_hardware_signature_knurled_brushed_bronze', `${BASE_URL}/internal-products/hardware/signature-knurled-brushed-bronze.webp`),
  },
  {
    id: 'signature-knurled-rose-gold',
    name: 'Signature Knurled Rose Gold',
    image: img('internal_products_hardware_signature_knurled_rose_gold', `${BASE_URL}/internal-products/hardware/signature-knurled-rose-gold.webp`),
  },
  {
    id: 'signature-knurled-satin-brass',
    name: 'Signature Knurled Satin Brass',
    image: img('internal_products_hardware_signature_knurled_satin_brass', `${BASE_URL}/internal-products/hardware/signature-knurled-satin-brass.webp`),
  },
  {
    id: 'signature-knurled-satin-stainless',
    name: 'Signature Knurled Satin Stainless',
    image: img('internal_products_hardware_signature_knurled_satin_stainless', `${BASE_URL}/internal-products/hardware/signature-knurled-satin-stainless.webp`),
  },
  {
    id: 'signature-knurled-turn-release-antique-brass',
    name: 'Signature Knurled Turn Release Antique Brass',
    image: img('internal_products_hardware_signature_knurled_turn_release_antique_brass', `${BASE_URL}/internal-products/hardware/signature-knurled-turn-release-antique-brass.webp`),
  },
  {
    id: 'signature-knurled-turn-release-brushed-black',
    name: 'Signature Knurled Turn Release Brushed Black',
    image: img('internal_products_hardware_signature_knurled_turn_release_brushed_black', `${BASE_URL}/internal-products/hardware/signature-knurled-turn-release-brushed-black.webp`),
  },
  {
    id: 'signature-knurled-turn-release-brushed-bronze',
    name: 'Signature Knurled Turn Release Brushed Bronze',
    image: img('internal_products_hardware_signature_knurled_turn_release_brushed_bronze', `${BASE_URL}/internal-products/hardware/signature-knurled-turn-release-brushed-bronze.webp`),
  },
  {
    id: 'signature-knurled-turn-release-rose-gold',
    name: 'Signature Knurled Turn Release Rose Gold',
    image: img('internal_products_hardware_signature_knurled_turn_release_rose_gold', `${BASE_URL}/internal-products/hardware/signature-knurled-turn-release-rose-gold.webp`),
  },
  {
    id: 'signature-knurled-turn-release-satin-brass',
    name: 'Signature Knurled Turn Release Satin Brass',
    image: img('internal_products_hardware_signature_knurled_turn_release_satin_brass', `${BASE_URL}/internal-products/hardware/signature-knurled-turn-release-satin-brass.webp`),
  },
  {
    id: 'signature-knurled-turn-release-satin-stainless',
    name: 'Signature Knurled Turn Release Satin Stainless',
    image: img('internal_products_hardware_signature_knurled_turn_release_satin_stainless', `${BASE_URL}/internal-products/hardware/signature-knurled-turn-release-satin-stainless.webp`),
  },
];

const HardwareStep = ({ selectedHardware, onSelect, product, style }) => {
  // Define hardware options based on product and style
  const getHardwareOptions = () => {
    // Aluminium Pivot doors hardware options
    if (style === 'aluminium-pivot-doors') {
      return [
        {
          id: 'round-bar-handle',
          name: 'Round Bar Handle',
          image: img('aluminium_doors_hardware_round_bar_handle', `${BASE_URL}/aluminium-doors/hardware/round-handle.jpg`),
        },
        {
          id: 'square-bar-handle',
          name: 'Square Bar Handle',
          image: img('aluminium_doors_hardware_square_bar_handle', `${BASE_URL}/aluminium-doors/hardware/square-bar-handle.jpg`),
        },
        {
          id: 'recessed-handle',
          name: 'Recessed Handle',
          image: img('aluminium_doors_hardware_recessed_handle', `${BASE_URL}/aluminium-doors/hardware/recessed-handle.jpg`),
        },
        {
          id: 'lever-handle',
          name: 'Lever/Lever Handle',
          image: img('aluminium_doors_hardware_lever_handle', `${BASE_URL}/aluminium-doors/hardware/lever-handle.jpg`),
        },
      ];
    }

    // Windows hardware options (Traditional/Modern)
    if (product === 'windows') {
      return [
        {
          id: 'traditional',
          name: 'Traditional',
          image: img('windows_hardware_traditional', `${BASE_URL}/windows/hardware/windows-traditional.jpg`),
        },
        {
          id: 'modern',
          name: 'Modern',
          image: img('windows_hardware_modern', `${BASE_URL}/windows/hardware/windows-modern.jpg`),
        },
      ];
    }

    // Composite Doors hardware options (Traditional/Modern)
    if (product === 'front-back-doors') {
      return [
        {
          id: 'traditional',
          name: 'Traditional',
          image: img('front_back_doors_hardware_traditional', `${BASE_URL}/front-back-doors/hardware/traditional.jpg`),
        },
        {
          id: 'modern',
          name: 'Modern',
          image: img('front_back_doors_hardware_modern', `${BASE_URL}/front-back-doors/hardware/modern.jpg`),
        },
      ];
    }

    // Aluminium doors hardware options
    if (product === 'aluminium-doors') {
      return [
        {
          id: 'round-bar-handle',
          name: 'Round Bar Handle',
          image: img('aluminium_doors_hardware_round_bar_handle', `${BASE_URL}/aluminium-doors/hardware/round-handle.jpg`),
        },
        {
          id: 'square-bar-handle',
          name: 'Square Bar Handle',
          image: img('aluminium_doors_hardware_square_bar_handle', `${BASE_URL}/aluminium-doors/hardware/square-bar-handle.jpg`),
        },
        {
          id: 'recessed-handle',
          name: 'Recessed Handle',
          image: img('aluminium_doors_hardware_recessed_handle', `${BASE_URL}/aluminium-doors/hardware/recessed-handle.jpg`),
        },
        {
          id: 'lever-handle',
          name: 'Lever/Lever Handle',
          image: img('aluminium_doors_hardware_lever_handle', `${BASE_URL}/aluminium-doors/hardware/lever-handle.jpg`),
        },
      ];
    }

    // Bifolding/French doors hardware options (Modern/Traditional)
    if (product === 'bifolding-sliding-french-doors') {
      return [
        {
          id: 'modern',
          name: 'Modern',
          image: img('bifolding_hardware_modern', `${BASE_URL}/bifolding-sliding-french-doors/hardware/modern.jpg`),
        },
        {
          id: 'traditional',
          name: 'Traditional',
          image: img('bifolding_hardware_traditional', `${BASE_URL}/bifolding-sliding-french-doors/hardware/traditional.jpg`),
        },
      ];
    }

    // Internal products door handles
    if (product === 'internal-products') {
      return internalDoorsHandles;
    }

    // Default hardware options for other products
    return [
      {
        id: 'chrome',
        name: 'Chrome',
        image: 'https://placehold.co/150x150?text=Chrome',
      },
      {
        id: 'black',
        name: 'Black',
        image: 'https://placehold.co/150x150?text=Black',
      },
      {
        id: 'gold',
        name: 'Gold',
        image: 'https://placehold.co/150x150?text=Gold',
      },
      {
        id: 'brushed-nickel',
        name: 'Brushed Nickel',
        image: 'https://placehold.co/150x150?text=Brushed+Nickel',
      },
      {
        id: 'antique-brass',
        name: 'Antique Brass',
        image: 'https://placehold.co/150x150?text=Antique+Brass',
      },
      {
        id: 'satin-chrome',
        name: 'Satin Chrome',
        image: 'https://placehold.co/150x150?text=Satin+Chrome',
      },
    ];
  };

  const hardwareOptions = getHardwareOptions();

  return (
    <div className="w-full">
      {/* Title */}
      <h2 className="mb-12 text-center text-[24px] font-bold text-black">
        Select Hardware Finish
      </h2>

      {/* Hardware Grid */}
      <div className="mx-auto max-w-[1200px] px-4">
        <div className={`grid gap-6 ${
          hardwareOptions.length === 2
            ? 'grid-cols-2 max-w-[600px] mx-auto'
            : hardwareOptions.length > 9
            ? 'grid-cols-2 sm:grid-cols-3 md:grid-cols-4'
            : 'grid-cols-2 sm:grid-cols-3'
        }`}>
          {hardwareOptions.map((hardware) => (
            <button
              key={hardware.id}
              onClick={() => onSelect(hardware.id)}
              type="button"
              className={`
                group relative flex flex-col items-center rounded-lg border-2 p-6 transition-all
                ${
                  selectedHardware === hardware.id
                    ? 'border-[#ED6B64] bg-gray-50'
                    : 'border-gray-200 hover:border-gray-300'
                }
              `}
            >
              {/* Hardware Image */}
              <div className="mb-4 h-32 w-32 overflow-hidden rounded-lg bg-white">
                <img
                  src={hardware.image}
                  alt={hardware.name}
                  className="h-full w-full object-cover"
                />
              </div>

              {/* Hardware Name */}
              <span className="text-center text-sm font-bold text-black">
                {hardware.name}
              </span>

              {/* Selected Indicator */}
              {selectedHardware === hardware.id && (
                <div className="absolute right-2 top-2 flex h-6 w-6 items-center justify-center rounded-full bg-[#ED6B64]">
                  <svg
                    className="h-4 w-4 text-white"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                </div>
              )}
            </button>
          ))}
        </div>

        {/* Note */}
        <div className={'flex items-center justify-center w-full'}>

        <p className="mx-auto mt-8 text-center text-sm text-gray-600">
          All hardware includes handles, hinges, and locking mechanisms in your selected finish.
        </p>
        </div>
      </div>
    </div>
  );
};

export default HardwareStep;
